import React, { useState, useContext } from "react";
import { AppContext } from "../../App";
import { TextField, Button, Box } from "@mui/material";

export default function AccountAdmin(){

  const { activeUser, setActiveUser, setChangesMade } = useContext(AppContext)
  const [viewOnly, setViewOnly] = useState(true)
  const [accountDetails, setAccountDetails] = useState(activeUser.adminDetails)

  const handleChange = (e) => {
    setAccountDetails({
      ...accountDetails,
      [e.target.name]: e.target.value
    })
  }

  async function submitChanges(e){
    e.preventDefault()
    const newDetails = { ...accountDetails }

    await fetch(`https://the-paper-pusher.herokuapp.com/updateAccount/${activeUser.username}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(newDetails)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
    toggleMode()
    setChangesMade(prev => prev+1)

  }

  console.log(accountDetails)

  const toggleMode = () => {
    setViewOnly(prev => !prev)
  }

  return (
    <div className="account">
      <h3>Account Info</h3>
      <Button onClick={toggleMode}>{viewOnly? "edit" : "done"}</Button>
      <Box
        component="form"
        sx={{
          '& .MuiTextField-root': { m: 1, width: '25ch' },
          display: 'flex', flexWrap: 'wrap', margin: '0 auto', justifyContent: 'center'
        }}
        noValidate
        autoComplete="off"
        >
        <div className="account-text-fields">
          <TextField
              onChange={handleChange}
              name="firstName"
              disabled={viewOnly}
              id="filled-disabled"
              label="First Name"
              defaultValue={activeUser.adminDetails.firstName}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="lastName"
              disabled={viewOnly}
              id="filled-disabled"
              label="Last Name"
              defaultValue={activeUser.adminDetails.lastName}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="username"
              disabled
              id="filled-disabled"
              label="Username"
              defaultValue={activeUser.adminDetails.username}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="password"
              type={viewOnly ? "password" : "text"}
              disabled={viewOnly}
              id="filled-disabled"
              label="Password"
              defaultValue={activeUser.adminDetails.password}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="bandName"
              disabled
              id="filled-disabled"
              label="Artist/ Band Name"
              defaultValue={activeUser.bandName}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="contactPerson"
              disabled={viewOnly}
              id="filled-disabled"
              label="Primary Contact"
              defaultValue={activeUser.adminDetails.contactPerson}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="email"
              disabled={viewOnly}
              id="filled-disabled"
              label="Email Address"
              defaultValue={activeUser.adminDetails.email}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="phone"
              disabled={viewOnly}
              id="filled-disabled"
              label="Phone"
              defaultValue={activeUser.adminDetails.phone}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="email2"
              disabled={viewOnly}
              id="filled-disabled"
              label="Secondary Email Address"
              defaultValue={activeUser.adminDetails.email2}
              variant="filled"
            />

            <h5>Bank Details</h5>

            <TextField
              onChange={handleChange}
              name="bankAccHolder"
              disabled={viewOnly}
              id="filled-disabled"
              label="Account Holder"
              defaultValue={activeUser.adminDetails.bankAccHolder}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="bankName"
              disabled={viewOnly}
              id="filled-disabled"
              label="Bank Name"
              defaultValue={activeUser.adminDetails.bankName}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="accNumber"
              disabled={viewOnly}
              id="filled-disabled"
              label="Account Number"
              defaultValue={activeUser.adminDetails.accNumber}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="branchCode"
              disabled={viewOnly}
              id="filled-disabled"
              label="Branch Code"
              defaultValue={activeUser.adminDetails.branchCode}
              variant="filled"
            />
            <TextField
              onChange={handleChange}
              name="accType"
              disabled={viewOnly}
              id="filled-disabled"
              label="Account Type"
              defaultValue={activeUser.adminDetails.accType}
              variant="filled"
            />


        </div>

      </Box>
      <Button onClick={submitChanges}>save</Button>
      



    </div>
  )
}